export const UPDATE_ACCOUNT_DETAILS = "UPDATE_ACCOUNT_DETAILS";
const initState = {
    accTyp: "",
    userID: "",
    emaildId: "",
    accountCode: "",
    lgnSrc: "",
    isImpersonated: null,
    userName: "",
    empOrDependent: "",
};
export default function accountDetailsReducer(state = initState, action) {
    switch (action.type) {
        case UPDATE_ACCOUNT_DETAILS:
            return Object.assign({}, action.payload);
        default:
            return state;
    }
}
